/* import __COLOCATED_TEMPLATE__ from './sh-payment-line-items-list-item.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
 * This is an individual list item withing a project line item list in the admin view
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'li',
  classNames: [
    'SH-c-sh-payment-line-items-list-item',
    'LSG-l-grid',
    'padding-top-bottom-16px',
    'border-top-lsg-black'
  ],
  classNameBindings: [
    '_isOddIndex:background-lsg-xlight-gray',
    '_isOddIndex::background-lsg-white'
  ],

  /**
   * Register services
   */
  stateManager: service('state-managers/routes/admin/accounting/payout/sh-payment'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {Number}
   */
  indexInTable: 0,

  /**
   * @param {ShPaymentLineItem}
   */
  shPaymentLineItem: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _isOddIndex: computed('indexInTable', function() {
    return this.get('indexInTable') % 2 === 1;
  }),

  actions: {
  }
});
